import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function AlertBanner() {
  return <div className="bg-gradient-to-r from-yellow-50 to-amber-50 border-b-2 border-yellow-200" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-17">
        <div className="flex items-start gap-3" data-id="element-18">
          <AlertCircleIcon className="text-red-600 flex-shrink-0 mt-0.5" size={24} data-id="element-19" />
          <p className="text-gray-900 font-medium" data-id="element-20">
            <span className="font-bold" data-id="element-21">UPDATE:</span> Cotevich is SELLING OUT
            faster than expected! Lock in your order NOW to get 40% OFF + FAST
            SHIPPING
          </p>
        </div>
      </div>
    </div>;
}